<template>
    <div class="errContainer">
        <div class="errWrap">
            <p class="tit">요청하신 페이지를 찾을 수 없습니다.</p>
            <p>잘못된 경로로 접근 하셨거나, 사용할 수 없는 웹사이트 주소 입니다.</p>
            <p>이용에 불편을 드려 죄송합니다.</p>
        </div>

        <div class="btnCenter errorPageBtnDiv">
            <a @click="goBack();" class="btnCommon"><span class="btnTxt">이전</span></a>
            <a href="/" class="btnCommon darkBlue btnMainError" title="메인으로 이동"><span class="btnTxt">메인으로 이동</span></a>
        </div>
    </div>
</template>
<script>
export default {
    data: () => {
        return {
            arraveNum: -1,
        }
    },
    created: function() {
        console.log(this.$router.history._startLocation);
        this.checkStartLocation(this.$router.history._startLocation);
    },
    methods: {
        checkStartLocation(startLocation) {
            let pathLang = startLocation.substr(0, 3);
            if(pathLang == '/kr' || pathLang == '/en') {
                this.setGoBack(startLocation);
            }
        },
        setGoBack(start) {
            var count = 0;
            var searchChar = "/";
            var pos = start.indexOf(searchChar); //pos는 0의 값을 가집니다.
            while (pos !== -1) {
                count++;
                pos = start.indexOf(searchChar, pos + 1); // 첫 번째 a 이후의 인덱스부터 a를 찾습니다.
            }
            if(count == 3 || count == 4 || count == 2) {
                this.arraveNum = -2;
            } else {
                this.arraveNum = -1;
            }
        },
        goBack() {
            this.$router.go(this.arraveNum);
        }
    }
}
</script>
<style scoped>
@import "../assets/css/error.css";
</style>